// Mock data for Finirio website

export const services = [
  {
    id: 'loans',
    title: 'Loans',
    icon: 'https://finirio.com/wp-content/uploads/elementor/thumbs/personal-150x150-1-qtb073u55pyppdu67yyashlb0fuk3mqi0s6u9s13rs.png',
    href: '/home-loan',
  },
  {
    id: 'investments',
    title: 'Investments',
    icon: 'https://finirio.com/wp-content/uploads/elementor/thumbs/profits-150x150-1-qtb073u5a3ucv6njnv1f03h5469pyt22lyncvx2trw.png',
    href: '/investments',
  },
  {
    id: 'debt',
    title: 'Debt Management',
    icon: 'https://finirio.com/wp-content/uploads/elementor/thumbs/debt-150x150-1-qtb073u5a3ucv6njnv1f03h5469pyt22lyncvx2trw.png',
    comingSoon: true,
  },
  {
    id: 'home-search',
    title: 'Home Search',
    icon: 'https://finirio.com/wp-content/uploads/elementor/thumbs/search-150x150-1-qtb072wb39t2jkowtcmsflpoisecr3yc9tzven47y4.png',
    comingSoon: true,
  },
];

export const banks = [
  { name: 'HDFC Bank', img: '/logos/hdfc.png' },
  { name: 'State Bank of India', img: '/logos/sbi.png' },
  { name: 'ICICI Bank', img: '/logos/icici.png' },
  { name: 'Axis Bank', img: '/logos/axis.jpg' },
  { name: 'Kotak Mahindra', img: '/logos/kotak.webp' },
  { name: 'Bank of Baroda', img: '/logos/bob.png' },
  { name: 'Standard Chartered', img: '/logos/sc.png' },
  { name: 'IDFC First Bank', img: '/logos/idfc.webp' },
  { name: 'IDBI Bank', img: '/logos/idbi.png' },
  { name: 'LIC Housing Finance', img: '/logos/lichfl.png' },
  { name: 'Tata Capital', img: '/logos/tata.jpg' },
];

export const howItWorks = [
  {
    id: 1,
    title: 'Check Eligibility',
    desc: 'Check your eligibility for a loan',
    icon: 'https://finirio.com/wp-content/uploads/elementor/thumbs/icon1-150x150-1-qtbzd5mco4ujt2gn9idg4pyrgehshiia9i6us2xwyo.png',
  },
  {
    id: 2,
    title: 'Submit Application',
    desc: 'Complete a 100% application form & Document Collection At Your Door Steps',
    icon: 'https://finirio.com/wp-content/uploads/elementor/thumbs/icon2-150x150-1-qtbz7cy6gpz2mqh2e24pndoiizuq34c3684sxl0gby.png',
  },
  {
    id: 3,
    title: 'Get Sanctioned',
    desc: 'We will evaluate your application propose a fair sanction',
    icon: 'https://finirio.com/wp-content/uploads/elementor/thumbs/icon3-396x360-1-qtbz7c0c9vxsb4ifjjq32vx1xlzcvf8cu3hbgb1ui6.png',
  },
  {
    id: 4,
    title: 'Receive Funds',
    desc: 'Receive your loan within 7 days',
    icon: 'https://finirio.com/wp-content/uploads/elementor/thumbs/icon4-150x150-1-qtbzd5mclxwq861yjkbw0x0ueja7jxchywylh0f1ym.png',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Ravindra Surude',
    role: 'Gastroenterologist',
    text: 'Outstanding service! They made my housing loan transfer hassle-free and saved me money on interest.',
    img: 'https://ui-avatars.com/api/?name=Ravindra+Surude&background=1e73be&color=fff&size=150&bold=true&rounded=true',
    rating: 4.5,
  },
  {
    id: 2,
    name: 'Jogesh Nair',
    role: 'Business Head',
    text: 'Streamlined housing loan process with unbeatable rates. Professional and reliable service every step of the way.',
    img: 'https://ui-avatars.com/api/?name=Jogesh+Nair&background=2ea690&color=fff&size=150&bold=true&rounded=true',
    rating: 5,
  },
  {
    id: 3,
    name: 'Hemant Rathod',
    role: 'Business Head',
    text: 'Efficient and transparent loan transfer experience. Great customer support and seamless process.',
    img: 'https://ui-avatars.com/api/?name=Hemant+Rathod&background=0f3d78&color=fff&size=150&bold=true&rounded=true',
    rating: 4.5,
  },
  {
    id: 4,
    name: 'Bushan Banuur',
    role: 'Tata Consumer Products (Vice President)',
    text: 'Top-notch service for housing loans! Smooth process and great support.',
    img: 'https://ui-avatars.com/api/?name=Bushan+Banuur&background=1e73be&color=fff&size=150&bold=true&rounded=true',
    rating: 4.5,
  },
  {
    id: 5,
    name: 'Vinay Agarwal',
    role: 'Vice President (Pedelite Industries)',
    text: 'Efficient and transparent loan transfer experience. Great customer support and seamless process.',
    img: 'https://ui-avatars.com/api/?name=Vinay+Agarwal&background=2ea690&color=fff&size=150&bold=true&rounded=true',
    rating: 4.5,
  },
  {
    id: 6,
    name: 'Parag Goel',
    role: 'Cluster Head (Lupin)',
    text: 'Loan transfer was a breeze with their expert team. Highly recommend for stress-free transactions.',
    img: 'https://ui-avatars.com/api/?name=Parag+Goel&background=0f3d78&color=fff&size=150&bold=true&rounded=true',
    rating: 5,
  },
];

export const heroImage = '/hero-image.png';

export const navigation = [
  {
    label: 'About us',
    href: '/about-us',
    children: [
      { label: 'About Finirio', href: '/about-us' },
      { label: 'Meet the Team', href: '/team' },
    ],
  },
  {
    label: 'Services',
    href: '/services',
    children: [
      { label: 'Home Loan', href: '/home-loan' },
      { label: 'Loan Against Property', href: '/loan-against-property' },
      { label: 'Business Loan', href: '/business-loan' },
      { label: 'Personal Loan', href: '/personal-loan' },
      { label: 'OD/CC / Working Capital', href: '/working-capital' },
      { label: 'Mutual Fund Investments', href: '/investments' },
    ],
  },
  {
    label: 'Calci and Docs',
    href: '/emi-calculator',
    children: [
      { label: 'EMI Calculator', href: '/emi-calculator' },
      { label: 'Eligibility Calculator', href: '/eligibility-calculator' },
      { label: 'Documents Required', href: '/documents' },
      { label: 'Loan Comparison', href: '/loan-comparison' },
      { label: 'Charges Calculator', href: '/charges-calculator' },
    ],
  },
  { label: 'Careers', href: '/careers' },
  { label: 'Become a partner', href: '/become-partner' },
  {
    label: 'Login',
    href: '/portal/login',
    children: [
      { label: 'Agent Panel', href: 'https://console.acefone.in/dialer/login', external: true },
    ],
  },
];
